const RICOS_VERSION = "10.131.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
